<div class="card p-4 d-flex flex-column mt-2">
  <nz-skeleton
    [ngClass]="loading ? 'p-3' : 'p-0'"
    [nzLoading]="loading"
    [nzActive]="true"
    [nzParagraph]="false"
  >
    <div class="py-1 title flex items-center gap-2">
      <Button
        style="border: none; background-color: transparent"
        (click)="back()"
      >
        <img
          src="https://storage.googleapis.com/komerce/assets/icons/back.svg"
          alt=""
          width="40px"
        />
      </Button>
      Upgrade Package
    </div>
    <hr />
  </nz-skeleton>
  <div
    class="d-flex flex-column text-center justify-content-center col-12 mt-1"
  >
    <nz-skeleton
      [ngClass]="loading ? 'p-3' : 'p-0'"
      [nzLoading]="loading"
      [nzActive]="true"
    >
      <div class="d-flex justify-content-center">
        <h4 style="font-weight: 600">Shipping Cost & Delivery API &nbsp;</h4>
        <img
          style="max-height: 30px"
          src="https://storage.googleapis.com/komerce/rajaongkir/RajaOngkir.svg"
        />
      </div>
      <span style="font-size: 18px; color: #828282"
        >Choose the package according to your needs</span
      >
      <div class="mt-4 d-flex justify-content-center align-items-center">
        <span style="font-size: 18px" [ngClass]="switchValue ? 'text-grey' : ''"
          >Monthly &nbsp;</span
        >
        <nz-switch
          [(ngModel)]="switchValue"
          (ngModelChange)="handleSwitch()"
        ></nz-switch>
        <span
          style="font-size: 18px"
          [ngClass]="switchValue ? '' : ' text-grey'"
        >
          &nbsp;Annualy&nbsp;</span
        >
        <span class="save mx-2">Save up to 50%</span>
      </div>
    </nz-skeleton>
  </div>
  <div class="mt-5 gap-5 d-flex justify-content-center" nz-row>
    <nz-card
      nzHoverable
      nz-col
      nzXs="24"
      nzSm="32"
      nzMd="24"
      nzLg="11"
      nzXl="7"
      class="p-4 gutter-row"
      style="height: 900px"
      [ngStyle]="setStyleCard(items.name)"
      *ngFor="let items of packageContent; let i = index"
    >
      <nz-skeleton
        [ngClass]="loading ? 'p-3' : 'p-0'"
        [nzLoading]="loading"
        [nzActive]="true"
      >
        <div class="d-flex flex-column">
          <div
            class="d-flex flex-column align-self-start"
            style="height: 800px"
          >
            <div *ngIf="items.name === 'Enterprise'" class="best">
              👑 Best Deals
            </div>
            <div class="d-flex align-items-center gap-3">
              <img [src]="items.icon" alt="starter-img" />
              <div class="d-flex flex-column">
                {{ items.use }}
                <span class="title text-uppercase">{{ items.name }}</span>
              </div>
            </div>
            <span
              class="mt-3"
              [ngClass]="
                items.name !== 'Enterprise' ? 'text-grey' : ' text-white'
              "
              style="font-size: 15px"
              >{{ items.desc }}</span
            >
            <div class="d-flex align-items-center mt-3">
              <span style="text-decoration: line-through; font-size: 16px">{{
                items.normalPrice
              }}</span>
              <span class="save mx-2">Save {{ items.saving }}</span>
            </div>
            <div class="d-flex flex-column mt-3 gap-1">
              <div class="d-flex align-items-center">
                <h5
                  [ngClass]="items.name !== 'Enterprise' ? '' : ' text-white'"
                  *ngIf="items.price !== 'Free'"
                >
                  Rp&nbsp;
                </h5>
                <h2
                  [ngClass]="items.name !== 'Enterprise' ? '' : ' text-white'"
                  style="font-weight: 600"
                >
                  {{ items.price }}
                </h2>
                <span>{{ switchValue ? "/year" : "/month" }}</span>
              </div>
              <span *ngIf="items.vat" style="margin-top: -16px"
                >Prices include 11% VAT</span
              >
            </div>
            <span class="mt-4"
              ><h5
                [ngClass]="items.name !== 'Enterprise' ? '' : ' text-white'"
                style="font-weight: 600"
              >
                What's Included
              </h5></span
            >
            <div
              *ngFor="let list of items.feature; let i = index"
              class="d-flex gap-3 mt-2 align-items-start"
            >
              <img
                [src]="
                  items.name !== 'Enterprise'
                    ? 'https://storage.googleapis.com/komerce/assets/icons/Checklist-fill.svg'
                    : 'https://storage.googleapis.com/komerce/assets/LP-Komads/Symbol checklist.svg'
                "
                alt="check"
                width="20px"
                class="mt-1"
              />
              <span
                [ngClass]="
                  items.name !== 'Enterprise' ? 'text-grey' : ' text-white'
                "
                style="font-size: 16px"
                >{{ list }}</span
              >
            </div>
            <div
              *ngFor="let list of items.nor; let i = index"
              class="d-flex gap-3 mt-2 align-items-start"
            >
              <img
                *ngIf="items.name !== 'Enterprise'"
                src="https://storage.googleapis.com/komerce/rajaongkir/cross-red.svg"
                alt="check"
                width="17px"
                class="mt-1"
                style="margin-left: 2px"
              />
              <span
                [ngClass]="
                  items.name !== 'Enterprise' ? 'text-grey' : ' text-white'
                "
                style="font-size: 16px"
                >{{ list }}</span
              >
            </div>
          </div>
          <div class="d-flex col-12 align-self-end mt-1" style="height: 100px">
            <button
              class="col-12 upgrade-button"
              [ngClass]="
                items.name === 'Starter' ||
                (items.name !== 'Enterprise' &&
                  activedPackage === 'enterprise') ||
                !agreedToTerms
                  ? 'disable-upgrade'
                  : ''
              "
              [disabled]="
                items.name === 'Starter' ||
                (items.name !== 'Enterprise' &&
                  activedPackage === 'enterprise') ||
                !agreedToTerms
              "
              nz-button
              nzSize="large"
              nzShape="round"
              style="font-weight: 600; height: 55px"
              [ngStyle]="setStyleButton(items.name)"
              (click)="handleUpgrade(items.name)"
            >
              {{ items.action }}
            </button>
          </div>
        </div>
      </nz-skeleton>
    </nz-card>
  </div>

  <div class="d-flex justify-content-center mt-4 mb-4">
    <label nz-checkbox [(ngModel)]="agreedToTerms">
      I agree to
      <a
        [href]="urlTnC"
        target="_blank"
        rel="noopener noreferrer"
        (click)="$event.stopPropagation()"
        >RajaOngkir terms & Conditions</a
      >
    </label>
  </div>
</div>
